"use client";

import React from "react";
import { Globe, MessageCircle, Server } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * PagemakerInAllCantons — Section 2: Einleitung mit lokalem USP
 * Drop-in für: src/pages/PagemakerInAllCantons/sections/Einleitung.tsx
 */

const usps = [{
  icon: Globe,
  title: "Schweizer Hosting",
  description: "Ihre Daten bleiben in der Schweiz. Server, Backups, Verschlüsselung — alles unter Schweizer Recht."
}, {
  icon: MessageCircle,
  title: "Support auf Deutsch",
  description: "Persönliche Ansprechpartner aus St. Gallen und Zürich. Kein Callcenter, kein Bot."
}, {
  icon: Server,
  title: "Lokale SEO inklusive",
  description: "Automatische Optimierung für lokale Google-Suchen — egal ob Coiffeur in Bern oder Restaurant in Lugano."
}];
export default function Einleitung() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-secondary py-20 md:py-24">
      <div ref={ref} className={`max-w-6xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Eine Plattform für die ganze Schweiz
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            Egal ob Sie in einem urbanen Zentrum oder im hintersten Tal arbeiten
            — Sie verdienen eine professionelle Website, die in der Schweiz
            gehostet, auf Deutsch unterstützt und für lokale Google-Suchen
            optimiert ist.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {usps.map((u, i) => <div key={i} className="bg-background border border-border rounded-xl p-7 text-center">
              <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <u.icon className="w-6 h-6" strokeWidth={1.5} />
              </div>
              <h3 className="text-lg font-bold text-foreground mb-2 tracking-tight">
                {u.title}
              </h3>
              <p className="text-sm leading-relaxed text-muted-foreground">
                {u.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}